<div class="chart-container" #chartContainer style="height: 350px"></div>
